import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";

import AudioRecorder from "../hooks/useAudioRecorder";
import StandardButton from "./StandardButton";
import { consola } from "consola";
import {
  formatDurationLabel,
  getAudioDurationSeconds,
} from "../utils/audio";
export default React.memo((props) => {
  const [open, setOpen] = React.useState(false);
  const recorder = React.useRef();
  const [recordingStartedAt, setRecordingStartedAt] = React.useState(null);

  React.useEffect(() => {
    setOpen(props.open);
    const mic = new AudioRecorder({ bitRate: 128 });
    recorder.current = mic;

    mic
      .start()
      .then(() => {
        consola.log("Recording started");
        setRecordingStartedAt(Date.now());
      })
      .catch((e) => {
        consola.log("Recording failed - possibly permissions");
        if (props.onDialogClosed) {
          props.onDialogClosed(null, null, null);
        }
        if (props.onError) {
          props.onError(e);
        }
        return;
      });

    return () => {
      recorder.current.stop();
    };
  }, [props.open]);

  return (
    <Dialog
      maxWidth="lg"
      open={open}
      onClose={() => {
        if (props.onDialogClosed) {
          props.onDialogClosed(null, null, null);
        }
      }}
    >
      <DialogTitle>Audio Message</DialogTitle>

      <DialogContent>
        <Typography>Recording. Tap Send when Done.</Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            recorder.current.dispose();
            setOpen(false);
            if (props.onDialogClosed) {
              props.onDialogClosed(null, null, null);
            }
          }}
          color="primary"
        >
          Cancel
        </Button>
        <StandardButton
          variant="secondary"
          onClick={async () => {
            try {
              const [buffer, blob] = await recorder.current.getMp3();

              let durationSeconds = 0;
              try {
                durationSeconds = await getAudioDurationSeconds(buffer);
              } catch (durationError) {
                consola.warn("Failed to calculate audio duration", durationError);
              }

              if (!durationSeconds && recordingStartedAt) {
                durationSeconds = (Date.now() - recordingStartedAt) / 1000;
              }

              const formattedDuration = formatDurationLabel(durationSeconds);

              if (props.onDialogClosed) {
                props.onDialogClosed(blob, buffer, formattedDuration);
              }
            } catch (error) {
              consola.error("Failed to retrieve audio message", error);
              alert("We could not retrieve your message");
            }
          }}
        >
          Send
        </StandardButton>
      </DialogActions>
    </Dialog>
  );
});
